/**
 * Labstep
 *
 * @module core/QrReader
 * @desc QrReader component
 */

import { Loadable } from 'labstep-web/core/Loadable';
import React from 'react';
import type { IQrReaderProps } from './types';

export const QrReaderComponent = React.lazy(() =>
  import('labstep-web/core/QrReader/component').then((module) => ({
    default: module.QrReader,
  })),
);

export const QrReader: React.FC<IQrReaderProps> = (props) => (
  <Loadable>
    <QrReaderComponent {...props} />
  </Loadable>
);
